// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progressDialogRoot[data-v-1257f1e4]\n{\n\tmax-width: 300px;\n\tbackground-color: #FFFFFF;\n}\n.dialogBody[data-v-1257f1e4]\n{\n\tpadding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
